import React, { Component } from "react";
import instance from "./axios-instance";
import Systems from "./SystemFunction";

class PopupManager extends Component {
    videoRef = React.createRef();

    constructor(props) {
        super(props);

        const hideToday = localStorage.getItem("hidePopupResToday") === "true";

        this.state = {
            currentPopupIndex: 0, // 0 = video step
            popups: [],
            showVideo: false,
            hideToday,
        };
    }

    async componentDidMount() {
        await this.getpopup();
        if (this.videoRef.current) {
            this.videoRef.current.volume = 0.5;
            // this.startVideo();  // เริ่มเล่นวิดีโอ
        }
    }

    // ฟังก์ชันเริ่มเล่นวิดีโอ
    startVideo = () => {
        if (this.videoRef.current) {
            // เริ่มเล่นวิดีโอและตั้งค่า muted เป็น true
            this.videoRef.current.play().then(() => {
                // หลังจากเล่นไปแล้ว ตั้งค่า muted=false เพื่อเปิดเสียง
                this.videoRef.current.muted = true;  // เริ่มต้นที่ muted

                // ใช้ setTimeout หรือ requestAnimationFrame เพื่อเปิดเสียงหลังจากวิดีโอเริ่มเล่น
                setTimeout(() => {
                    if (this.videoRef.current) {
                        this.videoRef.current.muted = false;  // เปิดเสียง
                    }
                }, 1000); // หน่วงเวลา 1 วินาที (ปรับได้ตามต้องการ)
            }).catch((error) => {
                console.error("Error playing the video:", error);
            });
        }
    };

    getpopup = () => {
        // instance
        //     .post("/api/v1/popuplist", {
        //         System: Systems,
        //         Cat_ID: 0,
        //         page: 1,
        //         type: 1,
        //     })
        //     .then(async (res) => {
        //         console.log("PPPOPPPIPPPPUP", res.data);
        //         if (res.data.status === 200) {
        //             this.setState({
        //                 popups: (res.data.message.tblPopupMenu1 || []).filter(
        //                     (popup) => popup.status === 1
        //                 ),
        //             });
        //         }
        //     })
        //     .catch(async (err) => { });
    };

    // ✅ TOTAL STEP = video (1 step) + popups.length
    getTotalSteps = () => {
        const base = this.state.showVideo ? 1 : 0;
        return base + this.state.popups.length;
    };


    handleNext = () => {
        if (this.videoRef.current && !this.videoRef.current.paused && this.videoRef.current.muted && this.state.currentPopupIndex === 0) {
            // ถ้าวิดีโอรันอยู่ ให้เปิดเสียง
            this.videoRef.current.pause();  // หยุดการเล่น
            this.videoRef.current.currentTime = 0;  // รีเซ็ตเวลาให้เริ่มต้น
            this.videoRef.current.play();  // เริ่มเล่นใหม่
            this.videoRef.current.muted = false;  // เปิดเสียง
            console.log("Video restarted and sound enabled.");
        } else {
            // ถ้าวิดีโอหยุด ให้เข้าสู่การเปลี่ยน state
            this.setState((prevState) => ({
                currentPopupIndex: Math.min(
                    prevState.currentPopupIndex + 1,
                    this.getTotalSteps() - 1
                ),
            }));
        }
    };


    //handleNext = () => {

    // this.setState((prevState) => ({
    //     currentPopupIndex: Math.min(
    //         prevState.currentPopupIndex + 1,
    //         this.getTotalSteps() - 1
    //     ),
    // }));
    //  };

    handleBack = () => {
        this.setState((prevState) => ({
            currentPopupIndex: Math.max(prevState.currentPopupIndex - 1, 0),
        }));
    };

    handleClose = () => {
        this.setState({ currentPopupIndex: null });
    };

    handleHideToday = () => {
        localStorage.setItem("hidePopupResToday", "true");
        this.setState({ hideToday: true, currentPopupIndex: null });
    };

    render() {
        const { currentPopupIndex, popups, hideToday, showVideo } = this.state;

        // ====== ใส่ลิ้งวิดีโอ static ตรงนี้เลย ======
        const STATIC_VIDEO_URL = "https://s3.newworld.center/1771071901978_5de15f0c-e792-4387-986e-96e2f68ec871.mp4";

        if (hideToday || currentPopupIndex === null) return null;
        const totalSteps = this.getTotalSteps();
        const isLastStep = currentPopupIndex === totalSteps - 1;


        const isVideoStep = showVideo && currentPopupIndex === 0;

        const popupIndex = showVideo ? currentPopupIndex - 1 : currentPopupIndex;
        const popup = !isVideoStep ? popups[popupIndex] : null;

        if (!isVideoStep && !popup) return null;

        return (
            <div
                key={isVideoStep ? "static-video" : popup.id}
                role="presentation"
                style={{ display: "block" }}
                className="MuiDialog-root MuiModal-root css-ks3red"
            >
                <div
                    aria-hidden="true"
                    className="MuiBackdrop-root css-919eu4"
                    style={{
                        opacity: 1,
                        transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)",
                    }}
                />
                <div tabIndex={0} data-testid="sentinelStart" />

                <div
                    className="MuiDialog-container MuiDialog-scrollPaper css-ekeie0"
                    role="presentation"
                    tabIndex={-1}
                    style={{
                        opacity: 1,
                        transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)",
                    }}
                >
                    <div
                        className="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation24 MuiDialog-paper MuiDialog-paperScrollPaper MuiDialog-paperWidthSm css-uhb5lp"
                        role="dialog"
                        aria-describedby="alert-dialog-description"
                        aria-labelledby="alert-dialog-title"
                    >
                        <h2
                            className="MuiTypography-root MuiTypography-h6 MuiDialogTitle-root css-ohyacs"
                            id="alert-dialog-title"
                        >
                            <p className="MuiTypography-root MuiTypography-body1 css-1rsvwou">
                                ประกาศ
                            </p>
                        </h2>

                        <div className="MuiDialogContent-root css-69br6q">
                            {isVideoStep ? (
                                <video
                                    ref={this.videoRef}
                                    src={STATIC_VIDEO_URL}
                                    autoPlay
                                    playsInline
                                    controls
                                    muted={true} // เริ่มต้นที่ muted
                                    volume={0.5}
                                    preload="metadata"
                                    style={{
                                        width: "100%",
                                        maxHeight: "90vh",
                                        borderRadius: 8,
                                        display: "block",
                                    }}
                                />
                            ) : (
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        position: "relative",
                                        maxWidth: "100%",
                                    }}
                                >
                                    <img
                                        alt=""
                                        aria-hidden="true"
                                        src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%271000%27%20height=%271200%27/%3e"
                                        style={{
                                            display: "block",
                                            maxWidth: "100%",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                        }}
                                    />
                                    <img
                                        alt="ประกาศ"
                                        src={popup.img}
                                        decoding="async"
                                        data-nimg="intrinsic"
                                        style={{
                                            position: "absolute",
                                            inset: 0,
                                            boxSizing: "border-box",
                                            padding: 0,
                                            border: "none",
                                            margin: "auto",
                                            display: "block",
                                            width: 0,
                                            height: 0,
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            minHeight: "100%",
                                            maxHeight: "100%",
                                        }}
                                    />
                                </span>
                            )}
                        </div>

                        <div className="MuiDialogActions-root MuiDialogActions-spacing css-14b29qc">
                            {currentPopupIndex > 0 && (
                                <button className="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-1ujsas3"
                                    onClick={this.handleBack}
                                >
                                    กลับ
                                </button>
                            )}

                            {!isLastStep ? (
                                <button className="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-1ujsas3"
                                    onClick={this.handleNext}
                                >
                                  
                                    {this.videoRef.current && !this.videoRef.current.paused && this.videoRef.current.muted && this.state.currentPopupIndex === 0 ? "เล่น" :"ต่อไป"}
                                </button>
                            ) : (
                                <>
                                    <button className="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-1ujsas3"
                                        onClick={this.handleHideToday}
                                    >
                                        ไม่แสดงอีกวันนี้
                                    </button>
                                    <button className="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-1ujsas3"
                                        onClick={this.handleClose}
                                    >
                                        ปิด
                                    </button>
                                </>
                            )}
                        </div>

                    </div>
                </div>

                <div tabIndex={0} data-testid="sentinelEnd" />
            </div>
        );
    }
}

export default PopupManager;
